import { mapState } from 'vuex';
import ApiService from '@/services/apiService';
import WGS84Service from '@/services/wgs84ProjectionService';
export default {
  name: 'ViewNiotaClassicGatewayManagementGWMap',
  data: function () {
    return {
      camera: {
        center: [0, 0],
        zoom: 13
      },
      gwItems: [],
      gwClusters: [],
      boundingBox: {},
      selectedCluster: {},
      filterWarning: false,
      filterAlert: false
    };
  },
  computed: {
    ...mapState('app', ['inpOutlined', 'inpFilled', 'image', 'color'])
  },
  watch: {
    filterWarning() {
      this.$refs.mapInstance.debouncedRequestClusterRequest();
    },
    filterAlert() {
      this.$refs.mapInstance.debouncedRequestClusterRequest();
    }
  },
  created() {
    this.filterWarning = this.$route.query.warning === 'true';
    this.filterAlert = this.$route.query.alert === 'true';
    this.loadGWs();
  },
  methods: {
    loadGWs(bounds = undefined) {
      this.$store.state.app.load = 10;
      this.$store.state.app.loading = true;
      let accountId = this.$route.params.accountId ? parseInt(this.$route.params.accountId) : this.$store.state.authentication.tenantId;
      const options = [this.filterWarning ? 'warning' : null, this.filterAlert ? 'alert' : null].filter(o => o);
      ApiService.gwMgmtFetchGeoData(accountId, bounds, options).then(data => {
        this.boundingBox = data.boundingBox;
        if (this.boundingBox.coordinates) {
          let northEast = {
            lat: -180,
            lon: -360
          };
          let southWest = {
            lat: 180,
            lon: 360
          };
          this.boundingBox.coordinates.forEach(c => {
            northEast.lat = Math.max(northEast.lat, c[1]);
            southWest.lat = Math.min(southWest.lat, c[1]);
            northEast.lon = Math.max(northEast.lon, c[0]);
            southWest.lon = Math.min(southWest.lon, c[0]);
          });
          const mapContainer = this.$refs.mapInstance.$el;
          const mapDimensions = {
            width: mapContainer.clientWidth - 30,
            height: mapContainer.clientHeight - 30
          };
          const zoomToUse = WGS84Service.boundsZoomLevel({
            northEast,
            southWest
          }, mapDimensions) - 0.5;
          this.camera = {
            center: data.boundingBox.centroid,
            zoom: zoomToUse
          };
        }
        this.gwItems = data.gateways;
        this.gwClusters = data.clusters;
      }).catch(error => {
        console.error('Error loading map-gateway-geo-data', error);
      }).finally(() => {
        this.$store.state.app.loading = false;
      });
    }
  }
};